import { createRouter, createWebHistory } from "vue-router";
import { trimRight } from "@/regira_modules/utilities/string-utility";
import routes from "./routes";
import appConfig from "@/app-config";

const baseUrl = trimRight(appConfig.baseUrl);

const router = createRouter({
  history: createWebHistory(baseUrl || "/"),
  routes,
});

export default router;
